angular.module('webcomm').controller('EndpointStatusChangedController', ['$scope', '$log', 'timeFormattingService', function ($scope, $log, timeFormattingService) {
    $scope.timeSent = timeFormattingService.formatFeedDate($scope.feedEvent.clientTime);

    $scope.$evalAsync(() => {
        $scope.$emit('timeForResize');
    });
}]);